import { render } from "./shift-list-model.vue?vue&type=template&id=3ffb4b2b"
import script from "./shift-list-model.vue?vue&type=script&lang=js"
export * from "./shift-list-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__